import ErrorRoutes from './routes'
import * as R from './utils/register'
import * as U from './utils/useLoginInit'
import Layout from './layout/index'
import { routesToMenus } from './utils/routesToMenus'
import fullscreen from './fullscreen'
import replaceSetUserInfoHookFunction from './utils/hooks/set-user-info'
import interceptResponse from './utils/hooks/intercept-response'
import storeRegister from './store/store'
import routerHook from './utils/hooks/router'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'layout-fullscreen-qiankun',
  title: 'Wiz全屏布局',
  version: '0.1.41',
  type: 'layout', // layout-布局模块  auth-认证模块  null|module-模块化
  description: '常用布局',
  // 存在，表明为layout模块
  component: Layout, // vue 组件
  // store/router 依赖注入，当前模块(views)与store耦合比较紧, 为其他layout预留注入
  init: async (store, router, config) => {
    storeRegister(store, router)
    routerHook(store, router)
    // 设定相关 Wiz.Hooks 为框架增加转换函数
    _.assign(Wiz.Hooks, {
      clearMenus: R.clearMenus,
      registerMenus: R.registerMenus,
      registerSysMenus: R.registerSysMenus,
      routesToMenus,
    })
    _.assign(Wiz.AuthHooks, {
      initRedirect: U.initRedirect,
      clearUserStorageInfo: U.clearUserStorageInfo,
      setProjectInfo: U.setProjectInfo,
    })
    // 未通过api进行layout附加，直接附加
    // ErrorRoutes[0].component = Layout
    // ErrorRoutes.forEach((r) => {
    //   router.addRoute(r)
    // })
    // / 内置 fullscreen
    Wiz.layout.instances.fullscreen = {
      name: 'layout-wiz-fullscreen',
      title: '全屏子布局',
      type: 'layout',
      version: '-',
      component: fullscreen,
      description: 'layout-wiz 内置全屏子layout',
    }
    // 运营商登录，显示管理模块菜单
    replaceSetUserInfoHookFunction()
    // 拦截请求响应
    interceptResponse(store, router)
  },
}
